import Purchase from '@components/LocalMerchant/LiveManage/Purchase'
import ReportForm from '@components/LocalMerchant/LiveManage/ReportForm'
import ReportFormView from '@components/LocalMerchant/LiveManage/ReportFormView'
import Showcase from '@components/LocalMerchant/LiveManage/Showcase'
import ReportFormSuperCase from '@components/ActivityPage/ReportFormSuperCase'
import LiveSales from '@components/ActivityPage/LiveSales'
import JiaMengHeader from '@components/JiaMeng/Header/MarketingCenter'
import ControlBoard from '@components/LocalMerchant/LiveManage/ControlBoard'
import LiveAccountRecharge from '@components/LocalMerchant/LiveManage/LiveAccountRecharge'
import RechargeRecord from '@components/LocalMerchant/LiveManage/RechargeRecord'
import ExpenseDetail from '@components/LocalMerchant/LiveManage/ExpenseDetail'
import LiveShowGuide from '@components/LocalMerchant/LiveManage/LiveShowGuide'
import {
  PRIVILEGE_NORMAL_ID,
  PRIVILEGE_STORE_ID,
  PRIVILEGE_GROUP_ID
} from '@constant'
import { asyncLoad, getRouteComponent } from '@util'

const AsyncManage = asyncLoad(() =>
  import('@components/LocalMerchant/LiveManage/Home')
)

// TODO
const config = {
  role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID, PRIVILEGE_GROUP_ID]
}

export default {
  path: 'liveManage',
  component: JiaMengHeader,
  indexRoute: {
    getComponent: getRouteComponent(AsyncManage, config)
  },
  stat: '直播管理/首页',
  childRoutes: [
    {
      path: 'purchase',
      getComponent: getRouteComponent(Purchase, config),
      stat: '直播管理/购买直播'
    },
    {
      path: 'reportForm(/:id)',
      getComponent: getRouteComponent(ReportForm, config),
      stat: '直播管理/发布直播'
    },
    {
      path: 'controlBoard(/:id)',
      getComponent: getRouteComponent(ControlBoard, config),
      stat: '直播管理/直播中控台'
    },
    {
      path: 'liveShowGuide',
      getComponent: getRouteComponent(LiveShowGuide, config),
      stat: '直播管理/直播帮助'
    },
    {
      path: 'reportFormView(/:id)',
      getComponent: getRouteComponent(ReportFormView, config),
      stat: '直播管理/查看提报单'
    },
    {
      path: 'showcase',
      getComponent: getRouteComponent(Showcase, config),
      stat: '直播管理/查看优秀案例'
    },
    {
      path: 'reportFormSuperCase',
      component: ReportFormSuperCase,
      stat: '直播管理/优秀案例'
    },
    {
      path: 'liveSales',
      component: LiveSales,
      stat: '直播管理/直播营销页'
    },
    {
      path: 'LiveAccountRecharge',
      component: LiveAccountRecharge,
      stat: '直播管理/直播账户充值'
    },
    {
      path: 'RechargeRecord',
      component: RechargeRecord,
      stat: '直播管理/充值记录'
    },
    {
      path: 'ExpenseDetail',
      component: ExpenseDetail,
      stat: '直播管理/消费明细'
    }
  ]
}
